import React from 'react'
import _ from 'lodash'
import { toast } from 'react-toastify'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import PortalGalleryImageForm from './PortalGalleryImageForm'
import config from '../../../config'
import { changePortal } from '../../../actions/portal'

class PortalGalleryImageFormContainer extends React.Component {
  state = {}

  initialValues = values => {
    console.log(values)
    return {
      title: config.getLangText(),
      description: config.getLangText(),
      externalUrl: '',
      ...values,
    }
  }

  handleSubmit = async (values, actions) => {
    if (this.props.onRequestClose) {
      this.props.onRequestClose(values)
    }
    actions.setSubmitting(false)
  }

  handleValidate = (values, props) => {
    var errors = {}
    return errors
  }

  render() {
    return (
      <PortalGalleryImageForm
        initialValues={this.initialValues(
          _.get(this.props.params, 'galleryImage'),
        )}
        language={this.props.language}
        onValidate={this.handleValidate}
        onSubmit={this.handleSubmit}
        onRequestClose={() => this.props.onRequestClose(null)}
      />
    )
  }
}

export default connect(
  ({ portal, info }) => ({
    language: info.language,
    portalID: portal._id,
    galleryImages: portal.galleryImages,
  }),
  dispatch => ({
    actions: bindActionCreators({ changePortal: changePortal }, dispatch),
  }),
)(PortalGalleryImageFormContainer)



// WEBPACK FOOTER //
// ./src/components/templates/portal-gallery-image/PortalGalleryImageFormContainer.js